export enum FlagType {
  AdvancedBulkClauseEditing = 'bulk-clause-editing-panel-ekp-19460',
  AgentSkillRunnerEnabled = 'agent-skill-runner-enabled-ekp-56252',
  AclMockFallback = 'acl-modal-ui-mock-fallback',
  AiReviewDeferred = 'ai-review-deferred-feature-ekp-65882',
  AribaControllerFlag = 'ariba-controller-flag',
  AribaEnableOutgoingFieldMapping = 'enable-outgoing-field-mapping-for-ariba-ekp-50425',
  AskAnything = 'ask-anything-ekp-23870',
  AskAnythingConversationHistory = 'ask-anything-conversation-history-EKP-24670',
  AskAnythingPreSig = 'ask-ai-in-pre-sig-ekp-24800',
  AskAnythingQuestionGroups = 'question-groups-ekp-24729',
  AskAiContractSetSummary = 'ask-ai-contract-set-summary',
  AskAiReportButton = 'ask-ai-show-copy-conversation-id-button-ekp-34330',
  AskAiSearchSkillEnabled = 'ask-ai-search-skill-enabled-ekp-52861',
  AskAiSearchSkillGa = 'ask-ai-search-skill-ga-ekp-67032',
  CCRecipients = 'ADD_CC_TO_ENVELOPE_EKP-12080',
  CheckFormFieldFileExtension = 'check-form-fields-uploaded-file-type-everest-ekp-14687',
  ClauseLibraryAiSuggest = 'ai-suggest-mvp-ekp-16394',
  ClauseAclUiModal = 'clause-level-acl-ekp-62373',
  ClientDeletionRolodexOrchestration = 'client-deletion-rolodex-orchestration-ekp-58002',
  ComponentMonitoringInSentry = 'enable-component-monitoring-in-sentry-ekp-23728',
  ContractActionsRenewal = 'contract-actions-renewal-ekp-56417',
  WorkflowContractType = 'wss-workflow-contract-type-ekp-41622',
  ConversationalAI = 'conversational-ai-ekp-18072',
  ConversationalAIButtonOnDocPageHeader = 'ask-ai-button-on-document-page-ekp-22487',
  CopyWorkflow = 'copy-workflow-ekp-26597',
  CreatePlaybookInPublishedStatus = 'create-playbook-in-published-status-ekp-55242',
  StdAiUrlMigration = 'std-ai-migration-url-renaming-ekp-64013',
  StandardToCustomAiTableUpdates = 'standard-to-custom-ai-table-updates-ekp-63138',
  LargeOptionListSupportInCustomAi = 'large-option-list-support-in-custom-ai',
  CustomAiCompositeFields = 'custom-ai-composite-fields-ekp-66500',
  CustomAiHighlightMethod = 'x-ray-highlight-save-method-DST-3863',
  CustomAiMesGroupsScope = 'custom-ai-mes-groups-scope-ekp-60644',
  CustomAiModelDebug = 'internal-only-custom-ai-model-debug-page-ekp-45816',
  CustomAiPublishIroning = 'custom-ai-publish-ironing-ekp-34197',
  CustomAiSuperAdminRepublishing = 'custom-ai-republishing-ekp-45471',
  CustomAiTableExtraction = 'custom-ai-table-extraction-ekp-41551',
  DashboardsEdsCharts = 'dashboards-eds-charts-ekp-51090',
  DashboardsExportExcel = 'dashboards-export-excel-ekp-14404',
  DashboardV3 = 'dashboards-v3-ekp-16349',
  DefaultDocumentEditor = 'default-document-editor-ekp-31853',
  DeprecateEditProvision = 'deprecate-doc-viewer-edit-provision-ekp-25488',
  DevOnlyAgentForgeInvoke = 'dev-only-agentforge-invoke-ekp-ekp-43869',
  DisableDocumentTableSorting = 'disable-document-table-sorting-ekp-22199',
  DocumentAclUiModal = 'acl-ui-modal-ekp-57406',
  DocumentDetailsInPostSig = 'document-details-panel-in-post-sig-ekp-29940',
  DocumentDetailsPanelUpdate = 'document-details-panel-update-ekp-47203',
  DocumentXRayBilling = 'document-x-ray-billing-EKP-21569',
  DocumentXRayCopilot = 'x-ray-copilot-ekp-33017',
  DocumentXRayDebugOutput = `document-x-ray-enable-llm-output-EKP-21757`,
  DocumentXrayNewPricingModel = 'x-ray-new-pricing-model-ekp-29738',
  DocumentXrayOptimize = 'document-x-ray-optimize-ekp-23418',
  DocumentXRayPrebuiltModels = 'x-ray-prebuilt-models-ekp-29135',
  DocumentXRayPrebuiltModelsAdmin = 'x-ray-prebuilt-models-admin-ekp-29684',
  DocumentXRayUnratedBoost = 'document-x-ray-allow-unrated-boost-ekp-23418',
  DocuSignSignWithEmail = 'ekp-31142-docusign-remove-captive-signer',
  DashboardV2DocumentsBulkActions = 'dashboard-v2-document-bulk-actions-ekp-20467',
  DynamicDataExtraction = 'dynamic-data-extraction-ekp-50207',
  DynamicDataExtractionTableLimits = 'dynamic-data-extraction-table-limits-ekp-56583',
  CanduScript = 'candu-script-ekp-24642',
  EditFieldInDocumentDetailsPanel = 'edit-field-in-document-details-panel-ekp-14850',
  EsignatureBundle = 'e-signature-bundle-ekp-41302',
  EsignDocusignDemoVendor = 'esign-docu-sign-demo-vendor',
  EnableNewEdsActions = 'enable-new-eds-actions',
  EnableNewEdsUser = 'enable-new-eds-user',
  EnableNewEdsUsers = 'enable-new-eds-users',
  EnableSsoDebugLogs = 'eng-only-enable-ui-sso-debug-logs',
  EnableWebhooksComponents = 'enable-webhooks-components-ekp-27770',
  FieldAi = 'field-ai-ekp-18695',
  FieldValueMigrationDeferredFeaturesBypass = 'fv-migration-deferred-features-bypass-EKP-15541',
  FilterChipApplyButton = 'filter-chip-apply-button-ekp-24057',
  FolderAccessSettings = 'folder-access-settings-ekp-27990',
  FolderSearchOptimization = 'folder-search-optimization-ekp-50484',
  GenAi = 'generative-ai-m1-ekp-15067',
  GenAiM2 = 'generative-ai-m2-ekp-14984',
  GenAiRedline = 'generative-ai-m1.5-ekp-15067',
  GuidelineRevamp = 'negotiation-requirements-revamp-ekp-58736',
  HideClauseAffordance = 'hide-clause-affordance-ekp-29816',
  HideDocumentStatus = 'hide-document-status-ekp-18469',
  HideLegacyMultiSelectShowMore = 'hide-legacy-multi-select-show-more-EKP-9594',
  HideShareButton = 'disable-share-document-button-ekp-18915',
  Home = 'newhome-ekp',
  HomeAdminSettings = 'home-admin-settings-ekp-63267',
  IntakeFormEDSComponents = 'intake-form-eds-components-ekp-31967',
  IntakeFormFieldWithReadOnly = 'intake-form-field-with-read-only-fields-ekp-24165',
  DocumentOverviewEditFormEDSComponents = 'document-overview-edit-form-eds-components',
  KeepHeaderNavigationMenuVisible = 'keep-header-navigation-menu-visible-ekp-52330',
  L1Languages = 'l1-languages-ekp-49972',
  LibraryManageAccess = 'library-manage-access',
  ManagedEntities = 'managed-entities-ekp-28298',
  MesPartiesMvp = 'mes-parties-mvp-EKP-54732',
  MicrosoftSharepointEmbedded = 'microsoft-sharepoint-embedded-ekp-31695',
  MicrosoftWordOnline = 'microsoft-word-online-ekp-52958',
  ModalConsolidation = 'modal-consolidation-ekp-46072',
  MultiDocWorkflowSupportAppendDocumentToContract = 'multi-doc-workflow-support-append-a-document-to-the-contract-ekp-31079',
  MultipleSfdcMigrationToEvi2ken = 'multiple-sfdc-migration-to-evi2ken-EKP-31518',
  NavigationBarLightTheme = 'navigation-bar-update-EKP-51139',
  NewIntegrationsPage = 'new-integrations-page-ekp-29665',
  Onboarding = 'bento-onboarding-ekp-20003',
  Playbooks = 'playbooks-ekp-30524',
  PlaybookAcl = 'playbooks-acl-EKP-58095',
  PlaybookTemplates = 'playbook-templates-EKP-47211',
  PlaybookUploadAiOutput = 'playbooks-ai-output-upload-ekp-50229',
  PlaybookExposeIntermediateOutputs = 'eng-only-playbook-expose-intermediate-agent-outputs-ekp-52754',
  PlaybookConflictResolution = 'playbook-conflict-resolution-ekp-52058',
  PlaybookBuilderPhase2Wizard = 'playbook-builder-phase2-conflict-resolution-wizard-enabled-ekp-59059',
  PlaybookReviewRedesign = 'ai-playbook-review-redesign-EKP-60948',
  DevOnlyUnifiedFieldsRegistryPlayground = 'dev-only-unified-fields-registry-playground',
  CreateCommentsForAiReviews = 'create-comments-for-ai-reviews-ekp-46495',
  PersistedTableDebounce = 'persisted-table-debounce-ekp-45648',
  PremiumPermissions = 'premium-permissions-ekp-19952',
  PremiumAdministration = 'premium-administration-ekp-20639',
  PreventSyncIfDuplicatesFoldersAreFound = 'prevent-sync-if-duplicates-are-found-ekp-40501',
  QueryBuilderEnabled = 'query-builder-enabled-ekp-32439',
  QuickAiFilters = 'quick-ai-filters-EKP-26523',
  QuickAiTableSorting = 'Quick-AI-table-sorting-EKP-13386',
  QueryFiltersIntoSearchAndDashboard = 'query-filters-into-search-dashboard-ekp-32858',
  RestorationHub500PageSize = 'restoration-hub-500-page-size-ekp-15159',
  ReactivateUsersEmailNotification = 'reactivate-user-email-notification-ekp-18548',
  RolodexAsUserDataSource = 'send-kafka-event-for-rolodex-user-changes-ekp-25303',
  RuleExtractionEnabled = 'rule-extraction-enabled-ekp-59053',
  SearchAsHomePage = 'search-as-home-page-EKP-14947',
  SearchPageResultsForAnalyzer = 'search-page-results-for-analyzer-ui-EKP-14679',
  SharedWithMe = 'shared-with-me-ekp-66710',
  SharepointWizard = 'sharepoint-wizard-ekp-40591',
  ShareQuestionGroup = 'share-question-group-ekp-23010',
  ShowHeaderForFullscreenModals = 'show-header-for-fullscreen-modals-ekp-32497',
  SidebarNav = 'sidebar-nav-ux-exploration',
  SidebarNavOnly = 'sidebar-nav-only-ekp-64370',
  SpeechToText = 'speech-to-text-ekp-53221',
  SuperAdminSamlSSO = 'super-admin-saml-sso-EKP-21264',
  SuperAdminCreateWorkdayTenant = 'super-admin-can-create-workday-tenant-ekp-29471',
  SupportMultipleSFDCOrganizations = 'support-multiple-sfdc-organizations-to-1-evisort-client-EKP-15844',
  SyncConfiguration = 'sync-configuration-ekp-22664',
  StorageConfiguration = 'storage-configuration-ekp-32115',
  TicketEmailActionWithComment = 'EMAIL-ACTIONS-COMMENT-EVEREST-EKP-14013',
  UnifiedDocumentDetailsPanel = 'document-table-details-panel-ekp-20186',
  UnifyDocumentViewer = 'unify-pdf-document-viewer-ekp-25127',
  UploadPageNew = 'revamp-upload-page-ekp-20203',
  Webhooks = 'webhooks-ekp-27768',
  WordEditingOnlineWorkflow = 'word-online-editing-workflow-EKP-20133',
  WSSDesignatedWorkflow = 'wss-designated-workflow-ekp-29829',
  WSSIntegrationM2Amendments = 'wss-integration-m-2-amendments-ekp-41091',
  WSSIntegrationPhase2M1M3 = 'wss-integration-phase-2-m-1-m-3',
  WSSIntegrationWorkflowBuilderIntegrationTypeSelector = 'wss-integration-integration-type-ekp-47373',
  FolderContentPrefetch = 'folder-content-prefetch-EKP-33732',
  SupportAddingCustomerBillingId = 'support-adding-customer-billing-id-in-super-admin-panel-ekp-41719',
  RefactoredInformationField = 'refactored-information-field-ekp-41213',
  SuperAdminUserManagementAndAuthProvider = 'super-admin-user-management-and-auth-provider-ekp-42787',
  CLMEvolutionPhase1 = 'clm-evolution-phase-1-ekp-40675',
  CLMR2October15Release = 'clm-r2-2026-10-15',
  CLMR2October31Release = 'clm-r2-2026-10-31',
  CLMR2TicketsDashboard = 'cml-r2--tickets-dashboard-ekp-61424',
  CLMEWorkflowBuilderAiStart = 'clme-workflow-builder-ai-start-ekp-54795',
  WSSIntegrationM4SupplierNegotiation = 'wss-integration-m-4-supplier-negotiation-ekp-40919',
  WSSIntegrationM6ProcurementMigration = 'wss-integration-m-6-procurement-migration-ekp-41111',
  CLMIntegrationDeferProcurementCreateNotification = 'clm-integration-defer-procurement-create-notification-ekp-50172',
  WSSIntegrationWithCLMEPhase1 = 'wss-integration-with-clme-phase-1-EKP-54164',
  TenantConnectivityTest = 'tenant-connectivity-test-ekp-45418',
  UnifiedFieldsM1 = 'pilot-unified-fields-enabled-ekp-49977',
  UnifiedFieldsM3 = 'pilot-unified-fields-enabled-m3-ekp-54902',
  UnifiedFieldNewClientOnboarding = 'unified-field-new-client-onboarding-ekp-60087',
  UnifiedFieldsMigrationMaintenance = 'legacy-to-uf-migration-maintenance-EKP-62347',
  ClmR2NewClientOnboarding = 'clmr2-new-client-onboarding-ekp-63965',
  EnableSchemaPerClient = 'enable-schema-per-client-ekp-52155',
  RefreshWorkdayTenantRegistration = 'ui-button-refreshing-workday-registration-EKP-60699',
}

export const STRING_VALUE_FLAGS = new Set<FlagType>([
  FlagType.CustomAiHighlightMethod,
  FlagType.DefaultDocumentEditor,
  FlagType.HomeAdminSettings,
]);

export const OBJECT_VALUE_FLAGS = new Set<FlagType>([
  FlagType.DynamicDataExtractionTableLimits,
]);

export type DynamicDataExtractionTableLimitsFlagValue = {
  max_models_per_table?: unknown;
  max_documents_per_table?: unknown;
};

export const DEFAULT_DYNAMIC_DATA_EXTRACTION_TABLE_LIMITS = {
  max_models_per_table: 5,
  max_documents_per_table: 100,
} as const satisfies DynamicDataExtractionTableLimitsFlagValue;

export type FlagValueMap = {
  [K in FlagType]: K extends
    | FlagType.CustomAiHighlightMethod
    | FlagType.DefaultDocumentEditor
    | FlagType.HomeAdminSettings
    ? string
    : K extends FlagType.DynamicDataExtractionTableLimits
      ? DynamicDataExtractionTableLimitsFlagValue
      : boolean;
};

const flags = {
  [FlagType.AclMockFallback]: false,
  [FlagType.DocumentAclUiModal]: true,
  [FlagType.ClauseAclUiModal]: true,
  [FlagType.PlaybookAcl]: false,
  [FlagType.AdvancedBulkClauseEditing]: true,
  [FlagType.AgentSkillRunnerEnabled]: false,
  [FlagType.AiReviewDeferred]: false,
  [FlagType.AribaEnableOutgoingFieldMapping]: false,
  [FlagType.AribaControllerFlag]: true,
  [FlagType.AskAnything]: true,
  [FlagType.AskAnythingConversationHistory]: true,
  [FlagType.AskAnythingPreSig]: true,
  [FlagType.AskAnythingQuestionGroups]: true,
  [FlagType.AskAiContractSetSummary]: true,
  [FlagType.AskAiReportButton]: true,
  [FlagType.AskAiSearchSkillEnabled]: false,
  [FlagType.AskAiSearchSkillGa]: false,
  [FlagType.CanduScript]: false,
  [FlagType.CCRecipients]: true,
  [FlagType.CheckFormFieldFileExtension]: true,
  [FlagType.ClauseLibraryAiSuggest]: false,
  [FlagType.ClientDeletionRolodexOrchestration]: false,
  [FlagType.CLMEvolutionPhase1]: true,
  [FlagType.CLMR2October15Release]: true,
  [FlagType.CLMR2October31Release]: true,
  [FlagType.CLMR2TicketsDashboard]: false,
  [FlagType.ComponentMonitoringInSentry]: false,
  // true in DEV_DEFAULTS only (this map) — local dev always shows the Renew
  // entry point the way RenewalDevTrigger's own `isDev` check used to. Real
  // environments still resolve this flag from LaunchDarkly, unaffected here.
  [FlagType.ContractActionsRenewal]: true,
  [FlagType.WorkflowContractType]: true,
  [FlagType.ConversationalAI]: true,
  [FlagType.ConversationalAIButtonOnDocPageHeader]: true,
  [FlagType.CopyWorkflow]: true,
  [FlagType.CreatePlaybookInPublishedStatus]: true,
  [FlagType.StdAiUrlMigration]: true,
  [FlagType.StandardToCustomAiTableUpdates]: true,
  [FlagType.LargeOptionListSupportInCustomAi]: true,
  [FlagType.CustomAiCompositeFields]: true,
  [FlagType.CustomAiHighlightMethod]: 'context_first',
  [FlagType.CustomAiMesGroupsScope]: true,
  [FlagType.CustomAiModelDebug]: true,
  [FlagType.CustomAiPublishIroning]: true,
  [FlagType.CustomAiSuperAdminRepublishing]: false,
  [FlagType.CustomAiTableExtraction]: true,
  [FlagType.DashboardsEdsCharts]: true,
  [FlagType.DashboardsExportExcel]: true,
  [FlagType.DashboardV3]: true,
  [FlagType.DefaultDocumentEditor]: 'evisort',
  [FlagType.EsignatureBundle]: true,
  [FlagType.DeprecateEditProvision]: false,
  [FlagType.DevOnlyAgentForgeInvoke]: true,
  [FlagType.DevOnlyUnifiedFieldsRegistryPlayground]: true,
  [FlagType.DisableDocumentTableSorting]: false,
  [FlagType.DocumentDetailsInPostSig]: true,
  [FlagType.DocumentDetailsPanelUpdate]: true,
  [FlagType.DocumentXRayBilling]: true,
  [FlagType.DocumentXRayCopilot]: false,
  [FlagType.DocumentXRayDebugOutput]: false,
  [FlagType.DocumentXrayNewPricingModel]: true,
  [FlagType.DocumentXrayOptimize]: true,
  [FlagType.DocumentXRayPrebuiltModels]: true,
  [FlagType.DocumentXRayPrebuiltModelsAdmin]: true,
  [FlagType.DocumentXRayUnratedBoost]: true,
  [FlagType.DocuSignSignWithEmail]: false,
  [FlagType.DashboardV2DocumentsBulkActions]: true,
  [FlagType.DynamicDataExtraction]: true,
  [FlagType.DynamicDataExtractionTableLimits]:
    DEFAULT_DYNAMIC_DATA_EXTRACTION_TABLE_LIMITS,
  [FlagType.EnableNewEdsActions]: true,
  [FlagType.EnableNewEdsUser]: true,
  [FlagType.EnableNewEdsUsers]: true,
  [FlagType.EnableSsoDebugLogs]: false,
  [FlagType.EnableWebhooksComponents]: false,
  [FlagType.EditFieldInDocumentDetailsPanel]: true,
  [FlagType.EsignDocusignDemoVendor]: false,
  [FlagType.FieldAi]: true,
  [FlagType.FieldValueMigrationDeferredFeaturesBypass]: false,
  [FlagType.FilterChipApplyButton]: true,
  [FlagType.FolderAccessSettings]: true,
  [FlagType.FolderSearchOptimization]: true,
  [FlagType.GenAi]: true,
  [FlagType.GenAiM2]: true,
  [FlagType.GenAiRedline]: true,
  [FlagType.GuidelineRevamp]: true,
  [FlagType.HideClauseAffordance]: false,
  [FlagType.HideDocumentStatus]: false,
  [FlagType.HideLegacyMultiSelectShowMore]: false,
  [FlagType.HideShareButton]: false,
  [FlagType.Home]: true,
  [FlagType.HomeAdminSettings]: '',
  [FlagType.IntakeFormEDSComponents]: true,
  [FlagType.IntakeFormFieldWithReadOnly]: true,
  [FlagType.DocumentOverviewEditFormEDSComponents]: true,
  [FlagType.KeepHeaderNavigationMenuVisible]: true,
  [FlagType.L1Languages]: true,
  [FlagType.LibraryManageAccess]: false,
  [FlagType.ManagedEntities]: false,
  [FlagType.MesPartiesMvp]: true,
  [FlagType.MicrosoftSharepointEmbedded]: true,
  [FlagType.MicrosoftWordOnline]: false,
  [FlagType.ModalConsolidation]: true,
  [FlagType.MultiDocWorkflowSupportAppendDocumentToContract]: false,
  [FlagType.MultipleSfdcMigrationToEvi2ken]: false,
  [FlagType.NavigationBarLightTheme]: false,
  [FlagType.NewIntegrationsPage]: false,
  [FlagType.Onboarding]: false,
  [FlagType.Playbooks]: true,
  [FlagType.PlaybookTemplates]: true,
  [FlagType.PlaybookUploadAiOutput]: false,
  [FlagType.PlaybookExposeIntermediateOutputs]: true,
  [FlagType.PlaybookConflictResolution]: true,
  [FlagType.PlaybookBuilderPhase2Wizard]: false,
  [FlagType.PlaybookReviewRedesign]: true,
  [FlagType.CreateCommentsForAiReviews]: true,
  [FlagType.PremiumPermissions]: true,
  [FlagType.PremiumAdministration]: true,
  [FlagType.PreventSyncIfDuplicatesFoldersAreFound]: true,
  [FlagType.QueryBuilderEnabled]: true,
  [FlagType.QueryFiltersIntoSearchAndDashboard]: true,
  [FlagType.QuickAiFilters]: true,
  [FlagType.QuickAiTableSorting]: false,
  [FlagType.ReactivateUsersEmailNotification]: true,
  [FlagType.PersistedTableDebounce]: true,
  [FlagType.RestorationHub500PageSize]: false,
  [FlagType.RolodexAsUserDataSource]: true,
  [FlagType.RuleExtractionEnabled]: false,
  [FlagType.SearchAsHomePage]: false,
  [FlagType.SearchPageResultsForAnalyzer]: false,
  [FlagType.SharedWithMe]: true,
  [FlagType.SharepointWizard]: true,
  [FlagType.ShareQuestionGroup]: false,
  [FlagType.SpeechToText]: true,
  [FlagType.ShowHeaderForFullscreenModals]: false,
  [FlagType.SidebarNav]: true,
  [FlagType.SidebarNavOnly]: false,
  [FlagType.SuperAdminSamlSSO]: true,
  [FlagType.SuperAdminCreateWorkdayTenant]: true,
  [FlagType.SupportMultipleSFDCOrganizations]: true,
  [FlagType.SyncConfiguration]: true,
  [FlagType.StorageConfiguration]: true,
  [FlagType.TicketEmailActionWithComment]: false,
  [FlagType.UnifiedDocumentDetailsPanel]: true,
  [FlagType.UnifyDocumentViewer]: true,
  [FlagType.UploadPageNew]: false,
  [FlagType.Webhooks]: true,
  [FlagType.WordEditingOnlineWorkflow]: true,
  [FlagType.WSSDesignatedWorkflow]: true,
  [FlagType.WSSIntegrationM2Amendments]: true,
  [FlagType.WSSIntegrationPhase2M1M3]: true,
  [FlagType.FolderContentPrefetch]: true,
  [FlagType.SupportAddingCustomerBillingId]: true,
  [FlagType.RefactoredInformationField]: true,
  [FlagType.SuperAdminUserManagementAndAuthProvider]: false,
  [FlagType.WSSIntegrationM4SupplierNegotiation]: true,
  [FlagType.CLMEWorkflowBuilderAiStart]: true,
  [FlagType.WSSIntegrationM6ProcurementMigration]: false,
  [FlagType.CLMIntegrationDeferProcurementCreateNotification]: true,
  [FlagType.WSSIntegrationWithCLMEPhase1]: true,
  [FlagType.TenantConnectivityTest]: true,
  [FlagType.WSSIntegrationWorkflowBuilderIntegrationTypeSelector]: true,
  [FlagType.UnifiedFieldsM1]: true,
  [FlagType.UnifiedFieldsM3]: true,
  [FlagType.UnifiedFieldNewClientOnboarding]: true,
  [FlagType.UnifiedFieldsMigrationMaintenance]: false,
  [FlagType.ClmR2NewClientOnboarding]: true,
  [FlagType.EnableSchemaPerClient]: true,
  [FlagType.RefreshWorkdayTenantRegistration]: false,
};

export const DEV_DEFAULTS: FlagValueMap = flags;

const isPlainObject = (
  value: unknown,
): value is DynamicDataExtractionTableLimitsFlagValue =>
  typeof value === 'object' &&
  value !== null &&
  (Object.getPrototypeOf(value) === Object.prototype ||
    Object.getPrototypeOf(value) === null);

export const coerceLaunchDarklyFlagValue = <F extends FlagType>(
  flag: F,
  value: unknown,
): FlagValueMap[F] => {
  if (OBJECT_VALUE_FLAGS.has(flag)) {
    if (isPlainObject(value)) {
      return value as FlagValueMap[F];
    }

    return flags[flag] as FlagValueMap[F];
  }

  if (STRING_VALUE_FLAGS.has(flag)) {
    return String(value ?? flags[flag]) as FlagValueMap[F];
  }

  return Boolean(value) as FlagValueMap[F];
};
